//DB WRITE PASSIERT HIER


import React, { useState, useEffect } from 'react';

import "../Player.css";

import MeldungSongGeAddedBody from "./MeldungSongGeAddedBody";
import { useStateValue } from "../StateProvider";

//FIREBASE HIER FUER DB WRITE
// auth für login
import { firestore, serverTimestamp, arrayUnion } from '../firebase';


//alles FireBase Import Start



function MeldungSongGeadded() {
  const [{trackIdSongToAdd, firebaseUid, userEmail, dbTrackSelection, dbUserRatings, NameOfAddedSong, blogConsentSongToAdd, genreSongToAdd}, dispatch] = useStateValue();

//INITIAL VALUE CURRENTRATINGS -> kommt aus DB bestehend
const [currentRatings, setCurrentRatings] = useState(
//inital value
null
); //hook example       

const [onlySetAllUploadedOnce, setOnlySetAllUploadedOnce] = useState(
  //inital value
  false
  ); //hook example

const [isAuthReady, setIsAuthReady] = useState(false); //hook for auth status    

//INITIAL VALUE COUNTDOWN ZEIGEN -> was ge-added wird
const [ratingsToAdd, setRatingsToAdd] = useState(
 //inital value
null
); //hook example

// Track previous entitled ratings for cumulative calculation
const [previousEntitledRatings, setPreviousEntitledRatings] = useState(0);

// Track current countRatings if song exists in dbTrackSelection
const [currentCountRatings, setCurrentCountRatings] = useState(null);

  //INITIAL VALUE COUNTDOWN ZEIGEN -> was ge-added wird
  const [meldungDBCountingsFetched, setMeldungDBCountingsFetched] = useState(
    //inital value
     0


); //hook example

  //INITIAL VALUE COUNTDOWN ZEIGEN -> was ge-added wird

  // Call getCurrentRatings when necessary data is available AND auth is ready
  useEffect(() => {
    async function getCurrentRatings() {
      if (!trackIdSongToAdd || !firebaseUid || !dbTrackSelection || !isAuthReady) {
        return;
      }

      try {
        // Check if song currently exists in dbTrackSelection (active carousel)
        const carouselSnapshot = await firestore.collection(dbTrackSelection).doc(trackIdSongToAdd+"|Firebase-User-Id:"+firebaseUid).get();

        if (carouselSnapshot.exists && carouselSnapshot.data()) {
          const currentCount = carouselSnapshot.data().countRatings;
          setCurrentCountRatings(currentCount || 0); // Default to 0 if countRatings is undefined
        } else {
          setCurrentCountRatings(null); // null means song not in carousel
        }

        // Check entitledRatingsPerSongPerUser for cumulative entitled ratings
        // This persists even after song is removed from carousel
        const entitledSnapshot = await firestore.collection("entitledRatingsPerSongPerUser").doc(trackIdSongToAdd+"|Firebase-User-Id:"+firebaseUid).get();

        if (!entitledSnapshot.exists || !entitledSnapshot.data()?.entitledRatings) {
          // First time adding this song OR entitledRatings field doesn't exist
          setPreviousEntitledRatings(0);
          setCurrentRatings(5);
        } else {
          // Song was added before, get previous entitled ratings
          const previousEntitled = entitledSnapshot.data().entitledRatings;
          setPreviousEntitledRatings(previousEntitled);
          // Always set currentRatings to 5 so that ratingsToAdd = 0 (triggers database write)
          setCurrentRatings(5);
        }
      } catch (error) {
        console.error('MeldungSongGeAdded: Error fetching data:', error);
        setPreviousEntitledRatings(0);
        setCurrentCountRatings(null);
        setCurrentRatings(5); // Default to 5 on error
      }
    }

    getCurrentRatings();
  }, [trackIdSongToAdd, firebaseUid, dbTrackSelection, isAuthReady]);

  useEffect(() => {

    //ANMELDEN BEI DB START
          // User is already authenticated via Firebase Auth
          // No need for signInAnonymously
          setIsAuthReady(true);
    //ANMELDEN BEI DB END


//promise ist 
// *! GET Current Ratings /-/ START




// *! GET Current Ratings /-/ END


                 //PROMISE -  START RATINGS GEHOLT



                  if (ratingsToAdd !== null && ratingsToAdd<=0 && isAuthReady) {



// erst wenn sie geändert sind anpassen!
        




             //reference to firestore collection ! UM REINSCHREIBEN ZU KÖNNEN
const tracksToRateRef = firestore.collection(dbTrackSelection);



            //IN DB SCHREIBEN TEIL 1 START

            // https://stackoverflow.com/questions/60940124/firebase-firestore-wait-for-update-to-complete-js-web
            // Calculate countRatings:
            // - If song not in carousel (currentCountRatings is null): start at 0
            // - If song exists in carousel: deduct 5 from current value (extends carousel time)
            const newCountRatings = currentCountRatings === null ? 0 : currentCountRatings - 5;

            const dataToWrite = {
              createdAt: serverTimestamp(),
              songName: NameOfAddedSong,
              trackid: trackIdSongToAdd,
              fromspotifyuser: firebaseUid,
              fromspotuserArr: arrayUnion(firebaseUid),
              fromSpotUserEmail: userEmail,
              countRatings: newCountRatings,
              blogConsent: blogConsentSongToAdd,
              genre: genreSongToAdd
            };

            tracksToRateRef.doc(trackIdSongToAdd+"|Firebase-User-Id:"+firebaseUid).set(dataToWrite).then(() => {
              // Mark that user has uploaded at least one song (for subsequent upload rules)
              localStorage.setItem('hasUploadedSong', 'true');

              // After successfully adding a song, prepare for next session with new songs
              const currentVisitCount = localStorage.getItem('songCarouselVisitCount');
              const nextCount = currentVisitCount ? ((parseInt(currentVisitCount, 10) % 3) + 1) : 2;
              localStorage.setItem('songCarouselVisitCount', nextCount.toString());
              // Clear the session start time so next visit will show new songs
              sessionStorage.removeItem('songCarouselSessionStart');

              // Send email notification to catchyrecords@gmail.com
              const mailToSend = firestore.collection("mail");

              mailToSend.add({
                to: "catchyrecords@gmail.com",
                bcc: [], // Required by security rules
                message: {
                  subject: 'Songcarousel.com: New Song Added - ' + NameOfAddedSong,
                  html: `
                    <h2>New Song Added to Song Carousel</h2>
                    <br/>
                    <p>A user has successfully added a new song to Song Carousel:</p>
                    <br/>
                    <ul>
                      <li><strong>Song:</strong> ${NameOfAddedSong}</li>
                      <li><strong>Spotify Track ID:</strong> ${trackIdSongToAdd}</li>
                      <li><strong>Firebase User ID:</strong> ${firebaseUid}</li>
                      <li><strong>User Email:</strong> ${userEmail || 'Not provided'}</li>
                      <li><strong>Genre:</strong> ${genreSongToAdd}</li>
                      <li><strong>Blog Consent:</strong> ${blogConsentSongToAdd ? 'Yes' : 'No'}</li>
                      <li><strong>Date Added:</strong> ${new Date().toLocaleString()}</li>
                    </ul>
                    <br/>
                    <p>This song is now available for rating in the carousel.</p>
                    <br/>
                    <hr/>
                    <p style="font-size: 12px; color: #666;">
                      This is an automated notification from Songcarousel.com
                    </p>
                  `
                }
              }).catch((error) => {
                console.error('MeldungSongGeAdded: Error sending email notification:', error);
              });

            }).catch((error) => {
              console.error('MeldungSongGeAdded: Error writing to tracksToRate:', error);
            });




    //IN DB SCHREIBEN TEIL 1 END


                            //IN_DB_SCHREIBEN USER RATINGS START
      
                            //DIES IST REF:
                            const songRatingsRef = firestore.collection(dbUserRatings);
    
                                      //FIREBASE ANONYM LOGIN START

                                                      //IST UPDATE BEI RATING
                              songRatingsRef.doc(firebaseUid+"-"+trackIdSongToAdd).set({

                              ratingdates: arrayUnion(),

                              tracknames: arrayUnion(),

                              ratingscores: arrayUnion(),

                              ratingBoxIdentifier: firebaseUid+"-"+trackIdSongToAdd



                              }, {merge: true}).catch((error) => {
                                console.error('MeldungSongGeAdded: Error writing to userRatings:', error);
                              });

               //UserRatinPool SET Song Ende      
                         //IN_DB_SCHREIBEN USER RATINGS ENDE

                 //IN_DB_SCHREIBEN ENTITLED RATINGS PER SONG PER USER - Start

              



                        const songEntitledRatingsRef = firestore.collection("entitledRatingsPerSongPerUser");
    
                

                                        //IST UPDATE BEI RATING
                songEntitledRatingsRef.doc(trackIdSongToAdd+"|Firebase-User-Id:"+firebaseUid).set({

                  createdAtUpdatedAt: serverTimestamp(),

                  songName: NameOfAddedSong,

                  trackIdOfSong: trackIdSongToAdd,
                  entitledRatings: previousEntitledRatings + 5, // Cumulative total: previous + 5 new ratings
                  fromspotifyuser: firebaseUid,



                }, {merge: true}).catch((error) => {
                  console.error('MeldungSongGeAdded: Error writing to entitledRatingsPerSongPerUser:', error);
                }); //damit ratings hochgezählt werden!!



                     //IN_DB_SCHREIBEN ENTITLED RATINGS PER SONG PER USER - Ende
            
                              //DB ALL UPLOADED SONGS START
                              // CREATE DATE
                              const trackunique = Date.now();
                              const uploadDate = trackunique;
                              const ratingDateToString = new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(uploadDate);


                              const allUploadedSongsRef = firestore.collection("allUploadedSongs");

                              if (onlySetAllUploadedOnce===false) {
                              allUploadedSongsRef.doc("allUploadedSongs").set({



                                                                                    // date,                    spotUserId,                 spotUserEmail,                  artistName-Songname, SpotSongId
                                allinfo: arrayUnion(ratingDateToString+"|Firebase-User-Id:"+firebaseUid+"|User-Email:"+userEmail+"|"+NameOfAddedSong+"|Track-Id:"+trackIdSongToAdd)




                              }, {merge: true}).catch((error) => {
                                console.error('MeldungSongGeAdded: Error writing to allUploadedSongs:', error);
                              });








                              setOnlySetAllUploadedOnce(true);

                            };
                               //DB ALL UPLOADED SONGS END

                            

                              







                                        //then end
                };



                  //PROMISE -  ENDE RATINGS GEHOLT

  }, [currentRatings, ratingsToAdd, trackIdSongToAdd, firebaseUid, NameOfAddedSong, userEmail, dbTrackSelection, dbUserRatings, onlySetAllUploadedOnce, isAuthReady, previousEntitledRatings, currentCountRatings, blogConsentSongToAdd, genreSongToAdd]);

// Anonymous LOGIN firebaese
// const [userfirebase] = useAuthState(auth);  //if User is logged-in: user is an Object // signed out: User is null

  // Handle currentRatings changes in useEffect
  useEffect(() => {
    if (currentRatings !== null && meldungDBCountingsFetched === 0) {
      const calculatedRatings = currentRatings - 5;

      // Gib Meldung an useEffect
      setRatingsToAdd(calculatedRatings);
      setMeldungDBCountingsFetched(1);

      dispatch({
        type: "SET_SHOWBUTTONBACKTOCAROUSEL",
        showButtonBackToCarousel: 1,
      });
    }
  }, [currentRatings, meldungDBCountingsFetched, dispatch]);




  return (
    <div className="player">
      <div className="player__body">
 
        <MeldungSongGeAddedBody />
      </div>
    
    </div>
  );



}
export default MeldungSongGeadded;
